import { STEP_IDS, STEPS } from 'constants/Steps';
import { hasPhoneRetrieval } from 'helpers/FormInformations';

/**
 * Get fields of step.
 * @param  {Object} step   Step of wanted fields
 * @param  {Object} values Form values
 * @return {Array}         List of fields
 */
export function getFields(step, values) {
    if (typeof step.fields === 'function') {
        return step.fields(values);
    }
    return step.fields;
}

/**
 * Find step number using step id
 * @param {string} id
 * @return {number} step number
 */
export function findStepNumberById(id) {
    return STEPS.findIndex((step) => step.id === id) + 1;
}

/**
 * Determine step number from current form values.
 * @param {Array} steps List of available steps
 * @param {Number} stepNumber Current step number from redux state
 * @param {Object} values Current form values
 * @param {Array} suggestedAddresses When filled address by user does not match perfectly
 * @param {Number} modifier Number added for determining next step (negative for go back)
 * @returns {Number} Number of next step
 */
export function computeNextStepNumber(
    steps,
    stepNumber,
    values,
    { suggestedAddresses = [], modifier = 1, auth = {} } = {},
) {
    const stepIndex = stepNumber - 1;
    let evaluatedIndex = stepIndex + modifier;

    while (
        evaluatedIndex < steps.length &&
        evaluatedIndex >= 0 &&
        steps[evaluatedIndex].condition
    ) {
        if (steps[evaluatedIndex].condition({ values, suggestedAddresses, modifier, auth })) {
            return evaluatedIndex + 1;
        }
        evaluatedIndex += modifier;
    }

    return Math.max(0, Math.min(steps.length, evaluatedIndex + 1));
}

/**
 * Check whether this is the last step or not
 * @param {Object} param
 * @param {Object} param.form Redux form state
 * @param {Object} param.step Redux step state
 * @param {Object} param.auth Redux auth state
 * @param {Object} param.address Redux address state
 */
export function isLastStep({ form, step, auth, address }) {
    const nextStepNumber = computeNextStepNumber(STEPS, step.number, form.values, {
        suggestedAddresses: address.suggestedAddresses,
        auth,
    });

    const isRetrievePhoneStep = step.id === STEP_IDS.retrievePhone;

    const isLoginStep = step.id === STEP_IDS.login;

    const isFakeAnimationStep = step.id === STEP_IDS.fakeAnimation;
    const isOneStepBeforeFakeAnimationStep =
        STEPS[nextStepNumber - 1].id === STEP_IDS.fakeAnimation;
    const isAuthenticated = !auth.needLogin;
    const userHasPhone = !hasPhoneRetrieval({ auth, values: form.values });
    const isAuthenticatedAndReadyToSubmit =
        isAuthenticated &&
        userHasPhone &&
        (isOneStepBeforeFakeAnimationStep || isFakeAnimationStep);

    return isRetrievePhoneStep || isLoginStep || isAuthenticatedAndReadyToSubmit;
}

export function isLoginStep(id) {
    return id === STEP_IDS.login;
}
